import useConfigStyles from '../../components/useConfigStyles';
import { useDataCertificationsContext } from '../../stores/data-certifications-context';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useState } from 'react';
import DeleteDataCertificationButton from 'components/data-certifications/DeleteDataCertificationButton';
import SnackbarAlert from 'components/Alerts';

export default function DataCertificationListPage(): JSX.Element {
  const classes = useConfigStyles();
  const dataCertificationsContext = useDataCertificationsContext();
  const dataCertifications = dataCertificationsContext.data;
  const [responseMessage, setResponseMessage] = useState('');
  const [notify, toggleNotification] = useState(false);

  const handleCloseSnackbar = () => {
    toggleNotification(false);
  };
  return (
    <>
      <SnackbarAlert open={notify} message={responseMessage} handleClose={handleCloseSnackbar} />
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label='Data Certification Table'>
          <TableHead>
            <TableRow className={classes.tableHeader}>
              <TableCell>DistrictId</TableCell>
              <TableCell>SchoolId</TableCell>
              <TableCell>IsCertified</TableCell>
              <TableCell>LastModifiedBy</TableCell>
              <TableCell>LastModified</TableCell>
              <TableCell>Delete</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dataCertifications.map((dataCertification) => (
              <TableRow key={dataCertification.Id} className={classes.tableRow}>
                <TableCell>{dataCertification.DistrictId}</TableCell>
                <TableCell>{dataCertification.SchoolId ? dataCertification.SchoolId : 'null'}</TableCell>
                <TableCell>{dataCertification.IsCertified ? 'Yes' : 'No'}</TableCell>
                <TableCell>{dataCertification.LastModifiedByUserId}</TableCell>
                <TableCell>{dataCertification.LastModifiedDateTime}</TableCell>
                <TableCell>
                  <DeleteDataCertificationButton
                    dataCertification={dataCertification}
                    onDeleteFail={(message) => {
                      setResponseMessage(message);
                      toggleNotification(true);
                    }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
